export const translations = {
  es: {
    // Auth
    login: 'Iniciar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    logout: 'Cerrar sesión',

    // Navigation
    calendar: 'Calendario',
    trainings: 'Entrenamientos',
    myTrainings: 'Mis Entrenamientos',
    exercises: 'Ejercicios',
    categories: 'Categorías',
    users: 'Usuarios',
    myStudents: 'Mis Alumnos',
    profile: 'Mi Perfil',

    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    create: 'Crear',
    close: 'Cerrar',
    search: 'Buscar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    back: 'Atrás',
    goBack: 'Volver',
    description: 'Descripción',

    // Training
    trainingDetails: 'Detalles del Entrenamiento',
    createTraining: 'Crear Entrenamiento',
    editTraining: 'Editar Entrenamiento',
    title: 'Título',
    date: 'Fecha',
    time: 'Hora',
    observations: 'Observaciones',
    restBetweenExercises: 'Descanso ejercicios (seg)',
    noTrainings: 'No hay entrenamientos',
    manageYourTrainings: 'Administra y visualiza todos tus entrenamientos creados',
    noTrainingsFound: 'No se encontraron entrenamientos',
    createFirstTraining: 'Crear primer entrenamiento',
    todayTrainings: 'Entrenamientos de Hoy',
    noTrainingsToday: 'No tienes entrenamientos para hoy',
    consultYourScheduledTrainings: 'Consulta tus entrenamientos programados',
    noTrainingsAssigned: 'No tienes entrenamientos asignados',
    trainingSummary: 'Resumen del entrenamiento',
    trainingTitle: 'Título del entrenamiento',
    trainingDescription: 'Descripción del entrenamiento',
    assignedUser: 'Usuario asignado',
    selectUser: 'Seleccionar usuario',
    warmup: 'Calentamiento',
    mainPart: 'Parte principal',
    cooldown: 'Estiramiento',
    startTraining: 'Iniciar Entrenamiento',
    rest: 'Descanso',
    skip: 'Saltar',
    start: 'Iniciar',
    pause: 'Pausar',
    progress: 'Progreso',
    trainingCompleted: '¡Entrenamiento Completado!',
    greatJob: '¡Excelente trabajo! Has completado tu entrenamiento.',
    backToCalendar: 'Volver al Calendario',
    nextExercise: 'Siguiente Ejercicio',

    // Exercise
    exercise: 'Ejercicio',
    repetitions: 'Repeticiones',
    seconds: 'Segundos',
    series: 'Series',
    restBetweenSeries: 'Descanso series (seg)',
    position: 'Posición',
    addExercise: 'Agregar Ejercicio',
    selectExercise: 'Seleccionar ejercicio',
    viewExercises: 'Ver ejercicios',
    imageUrl: 'URL de la imagen',
    videoUrl: 'URL del video',
    video: 'Vídeo',
    watchVideo: 'Ver vídeo',
    imagePreview: 'Vista previa de la imagen',
    availableExercises: 'Ejercicios disponibles',
    clickToAdd: 'Haz clic en un ejercicio para añadirlo',
    noExercisesAdded: 'No se han añadido ejercicios',
    totalExercises: 'Total de ejercicios',

    // Category
    category: 'Categoría',
    categoryName: 'Nombre de la categoría',
    categoryPhases: 'Fases del entrenamiento',
    allPhases: 'Todas las fases',
    availableIn: 'Disponible en',

    // User
    name: 'Nombre',
    role: 'Rol',
    user: 'Usuario',
    student: 'Alumno',
    coach: 'Entrenador',
    admin: 'Administrador',
    actions: 'Acciones',
    createUser: 'Crear Usuario',
    editUser: 'Editar Usuario',
    deleteUser: 'Eliminar Usuario',
    confirmDeleteUser: '¿Estás seguro de que quieres eliminar este usuario?',
    userCreated: 'Usuario creado exitosamente',
    userUpdated: 'Usuario actualizado exitosamente',
    userDeleted: 'Usuario eliminado exitosamente',
    username: 'Nombre de usuario',
    changeUserPassword: 'Cambiar Contraseña',
    passwordUpdated: 'Contraseña actualizada exitosamente',

    // Profile
    accountInformation: 'Información de la Cuenta',
    accountDetails: 'Detalles de tu cuenta',
    accountType: 'Tipo de cuenta',
    status: 'Estado',
    active: 'Activo',
    memberSince: 'Miembro desde',
    updateProfile: 'Actualizar Perfil',
    changePassword: 'Cambiar Contraseña',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',

    // Messages
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Error al iniciar sesión',
    logoutSuccess: 'Sesión cerrada exitosamente',
    profileUpdated: 'Perfil actualizado exitosamente',
    passwordChanged: 'Contraseña cambiada exitosamente',
    trainingCreated: 'Entrenamiento creado exitosamente',
    trainingUpdated: 'Entrenamiento actualizado exitosamente',
    trainingDeleted: 'Entrenamiento eliminado exitosamente',
    exerciseCreated: 'Ejercicio creado exitosamente',
    exerciseUpdated: 'Ejercicio actualizado exitosamente',
    exerciseDeleted: 'Ejercicio eliminado exitosamente',
    categoryCreated: 'Categoría creada exitosamente',
    categoryUpdated: 'Categoría actualizada exitosamente',
    categoryDeleted: 'Categoría eliminada exitosamente',
    confirmDelete: '¿Estás seguro de que quieres eliminar este elemento?',
  },
  en: {
    // Auth
    login: 'Login',
    email: 'Email',
    password: 'Password',
    logout: 'Logout',

    // Navigation
    calendar: 'Calendar',
    trainings: 'Trainings',
    myTrainings: 'My Trainings',
    exercises: 'Exercises',
    categories: 'Categories',
    users: 'Users',
    myStudents: 'My Students',
    profile: 'My Profile',

    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    create: 'Create',
    close: 'Close',
    search: 'Search',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    back: 'Back',
    goBack: 'Go Back',
    description: 'Description',

    // Training
    trainingDetails: 'Training Details',
    createTraining: 'Create Training',
    editTraining: 'Edit Training',
    title: 'Title',
    date: 'Date',
    time: 'Time',
    observations: 'Observations',
    restBetweenExercises: 'Rest between exercises (sec)',
    noTrainings: 'No trainings',
    manageYourTrainings: 'Manage and view all your created trainings',
    noTrainingsFound: 'No trainings found',
    createFirstTraining: 'Create first training',
    todayTrainings: "Today's Trainings",
    noTrainingsToday: 'You have no trainings for today',
    consultYourScheduledTrainings: 'Check your scheduled trainings',
    noTrainingsAssigned: 'You have no trainings assigned',
    trainingSummary: 'Training summary',
    trainingTitle: 'Training title',
    trainingDescription: 'Training description',
    assignedUser: 'Assigned user',
    selectUser: 'Select user',
    warmup: 'Warm-up',
    mainPart: 'Main part',
    cooldown: 'Cool-down',
    startTraining: 'Start Training',
    rest: 'Rest',
    skip: 'Skip',
    start: 'Start',
    pause: 'Pause',
    progress: 'Progress',
    trainingCompleted: 'Training Completed!',
    greatJob: 'Great job! You have completed your training.',
    backToCalendar: 'Back to Calendar',
    nextExercise: 'Next Exercise',

    // Exercise
    exercise: 'Exercise',
    repetitions: 'Repetitions',
    seconds: 'Seconds',
    series: 'Series',
    restBetweenSeries: 'Rest between series (sec)',
    position: 'Position',
    addExercise: 'Add Exercise',
    selectExercise: 'Select exercise',
    viewExercises: 'View exercises',
    imageUrl: 'Image URL',
    videoUrl: 'Video URL',
    video: 'Video',
    watchVideo: 'Watch video',
    imagePreview: 'Image preview',
    availableExercises: 'Available exercises',
    clickToAdd: 'Click on an exercise to add it',
    noExercisesAdded: 'No exercises added',
    totalExercises: 'Total exercises',

    // Category
    category: 'Category',
    categoryName: 'Category name',
    categoryPhases: 'Training phases',
    allPhases: 'All phases',
    availableIn: 'Available in',

    // User
    name: 'Name',
    role: 'Role',
    user: 'User',
    student: 'Student',
    coach: 'Coach',
    admin: 'Administrator',
    actions: 'Actions',
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    username: 'Username',
    changeUserPassword: 'Change Password',
    passwordUpdated: 'Password updated successfully',

    // Profile
    accountInformation: 'Account Information',
    accountDetails: 'Your account details',
    accountType: 'Account type',
    status: 'Status',
    active: 'Active',
    memberSince: 'Member since',
    updateProfile: 'Update Profile',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',

    // Messages
    loginSuccess: 'Login successful',
    loginError: 'Login error',
    logoutSuccess: 'Logout successful',
    profileUpdated: 'Profile updated successfully',
    passwordChanged: 'Password changed successfully',
    trainingCreated: 'Training created successfully',
    trainingUpdated: 'Training updated successfully',
    trainingDeleted: 'Training deleted successfully',
    exerciseCreated: 'Exercise created successfully',
    exerciseUpdated: 'Exercise updated successfully',
    exerciseDeleted: 'Exercise deleted successfully',
    categoryCreated: 'Category created successfully',
    categoryUpdated: 'Category updated successfully',
    categoryDeleted: 'Category deleted successfully',
    confirmDelete: 'Are you sure you want to delete this item?',
  },
};

export type TranslationKey = keyof typeof translations.es;
export type Language = keyof typeof translations;
